<template>
  <section class="exhibitor-inner-two" id="app">
    <div class="container-row">
      <div class="heading-row heading-row-v4">
      </div>
      <ExhibitorList />
    </div>
  </section>
</template>

<script>
import ExhibitorList from "./ExhibitorList/ExhibitorListing";
export default {
  name: "exhibitorlist",
  components: {
    ExhibitorList
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  }
};
</script>





